/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFBTechsAggregatedRecord
 */
export interface CRSFBTechsAggregatedRecord {
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    asset: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFBTechsAggregatedRecord
     */
    category: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    cpe: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFBTechsAggregatedRecord
     */
    created: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFBTechsAggregatedRecord
     */
    cves: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFBTechsAggregatedRecord
     */
    data: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof CRSFBTechsAggregatedRecord
     */
    found: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    module: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFBTechsAggregatedRecord
     */
    port: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    protocol: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    se_version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFBTechsAggregatedRecord
     */
    shared: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    source_asset: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    tech_key: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    tech_name: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFBTechsAggregatedRecord
     */
    version: string;
}

/**
 * Check if a given object implements the CRSFBTechsAggregatedRecord interface.
 */
export function instanceOfCRSFBTechsAggregatedRecord(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "cpe" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "cves" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "module" in value;
    isInstance = isInstance && "port" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "protocol" in value;
    isInstance = isInstance && "shared" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "source_asset" in value;
    isInstance = isInstance && "tech_key" in value;
    isInstance = isInstance && "tech_name" in value;
    isInstance = isInstance && "version" in value;

    return isInstance;
}

export function CRSFBTechsAggregatedRecordFromJSON(json: any): CRSFBTechsAggregatedRecord {
    return CRSFBTechsAggregatedRecordFromJSONTyped(json, false);
}

export function CRSFBTechsAggregatedRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFBTechsAggregatedRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'category': json['category'],
        'cpe': json['cpe'],
        'created': json['created'],
        'cves': json['cves'],
        'data': json['data'],
        'found': json['found'],
        'module': json['module'],
        'port': json['port'],
        'process_id': json['process_id'],
        'protocol': json['protocol'],
        'se_version': !exists(json, 'se_version') ? undefined : json['se_version'],
        'shared': json['shared'],
        'source': json['source'],
        'source_asset': json['source_asset'],
        'tech_key': json['tech_key'],
        'tech_name': json['tech_name'],
        'version': json['version'],
    };
}

export function CRSFBTechsAggregatedRecordToJSON(value?: CRSFBTechsAggregatedRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'category': value.category,
        'cpe': value.cpe,
        'created': value.created,
        'cves': value.cves,
        'data': value.data,
        'found': value.found,
        'module': value.module,
        'port': value.port,
        'process_id': value.process_id,
        'protocol': value.protocol,
        'se_version': value.se_version,
        'shared': value.shared,
        'source': value.source,
        'source_asset': value.source_asset,
        'tech_key': value.tech_key,
        'tech_name': value.tech_name,
        'version': value.version,
    };
}

